import {
  Dialog,
  Toast,
} from 'vant';
import store from '../store';
import router from '../router';


// 修改state的方法
function commit(variable, value) {
  store.commit('modifyValue', {
    variable,
    value,
  });
}

// 获取页面传过来的值
function parseUrl() {
  let url = location.href.substring(location.href.indexOf('#'), location.href.length);
  url = url.substring(url.indexOf('?') + 1, url.length);
  const cookierepl = url.replace(/['" ]/g, '');
  const cookObject = new Object();
  const cookieList = cookierepl.split('&');
  cookieList.map((item) => {
    cookObject[item.split('=')[0]] = decodeURI(item.split('=')[1]);
  });
  return cookObject;
}

// 显示加载框
function showload(text) {
  Toast.loading({
    message: text,
    forbidClick: true,
    duration: 0,
  });
}
// 隐藏加载框
function hidload() {
  Toast.clear();
}
// 显示消息框
function showMessage(text) {
  Toast(text);
}

function Message(title, message) {
  return new Promise((resolve, reject) => {
    Dialog.confirm({
      title: '提示',
      message,
    }).then(() => {
      // on confirm
      resolve(true);
    }).catch(() => {
      // on cancel
      resolve(false);
    });
  });
}

// 获取支付接口
function pay(payApp, param) {
  return new Promise((resolve, reject) => {
    showload('处理中...');
    payApp(param).then((res) => {
      switch (param.payment_type) {
        case 'wx':
          wx_pay(res.data, param).then((info) => {
            resolve(info);
          });
          break;
      }
    });
  });
}

// 微信支付逻辑
function wx_pay(data, param) {
  return new Promise((resolve, reject) => {
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        appId: data.appId, // 公众号名称，由商户传入
        timeStamp: data.timeStamp, // 时间戳，自1970年以来的秒数
        nonceStr: data.nonceStr, // 随机串
        package: data.package,
        signType: data.signType, // 微信签名方式：
        paySign: data.paySign, // 微信签名
      },
      (res) => {
        if (param.param_type == true) {
          setTimeout(() => {
            hidload();
            resolve(res.err_msg);
          }, 4000);
          return;
        }
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          handle(param);
        } else {
          hidload();
        }
      },
    );
  });
}

// 支付完成后的处理
function handle(param) {
  let url = '/contactCatalog/index';
  if (param.param_type.length > 0) {
    url = param.param_type;
  }
  setTimeout(() => {
    hidload();
    router.push({
      path: url,
    });
  }, 4000);
}

// 倒计时
function showLogin(mineList) {
  const goodsList = [];
  let time_close = false;

  return new Promise((resolve, reject) => {
    if (mineList.length > 0) {
      for (let i = 0; i < mineList.length; i++) {
        if (mineList[i].time_arr.hour != 0 || mineList[i].time_arr.second != 0 || mineList[i].time_arr.minute != 0) {
          if (mineList[i].time_arr.hour != 0 && mineList[i].time_arr.minute == 0) {
            mineList[i].time_arr.hour = mineList[i].time_arr.hour - 1;
            mineList[i].time_arr.minute = 59;
          }
          if (mineList[i].time_arr.minute != 0 && mineList[i].time_arr.second == 0) {
            mineList[i].time_arr.minute = mineList[i].time_arr.minute - 1;
            mineList[i].time_arr.second = 60;
          }
          if (mineList[i].time_arr.second != 0) {
            mineList[i].time_arr.second = mineList[i].time_arr.second - 1;
          }

          // /////////////////////////倒计时回调//////////////////////////////////////////////////
          if (mineList[i].time_arr.hour == 0 && mineList[i].time_arr.second == 0 && mineList[i].time_arr.minute
            == 0) {
            time_close = true;
          }
          // ////////////////////////////////////////////////////////////////////////////////////
        }

        goodsList.push(mineList[i]);
      }
      resolve({
        list: goodsList,
        time_close,
      });
    }
  });
}

function setItem(params) {
  const obj = {
    name: '',
    value: '',
    expires: 30 * 60 * 1000,
    startTime: new Date().getTime(), // 记录何时将值存入缓存，毫秒级
  };
  const options = {};
  // 将obj和传进来的params合并
  Object.assign(options, obj, params);
  if (options.expires) {
    // 如果options.expires设置了的话
    // 以options.name为key，options为值放进去
    localStorage.setItem(options.name, JSON.stringify(options));
  } else {
    // 如果options.expires没有设置，就判断一下value的类型
    Object.prototype.toString.call(options.value);
    // 如果value是对象或者数组对象的类型，就先用JSON.stringify转一下，再存进去
    if (Object.prototype.toString.call(options.value) == '[object Object]') {
      options.value = JSON.stringify(options.value);
    }
    if (Object.prototype.toString.call(options.value) == '[object Array]') {
      options.value = JSON.stringify(options.value);
    }
    localStorage.setItem(options.name, options.value);
  }
}
// 拿到缓存
function getItem(name) {
  let item = localStorage.getItem(name);
  // 先将拿到的试着进行json转为对象的形式
  try {
    item = JSON.parse(item);
  } catch (error) {
    // 如果不行就不是json的字符串，就直接返回
    return item;
  }
  // 如果有startTime的值，说明设置了失效时间
  if (item && item.startTime) {
    const date = new Date().getTime();
    // 何时将值取出减去刚存入的时间，与item.expires比较，如果大于就是过期了，如果小于或等于就还没过期
    if (date - item.startTime > item.expires) {
      // 缓存过期，清除缓存，返回false
      localStorage.removeItem(name);
      return false;
    }
    // 缓存未过期，返回值
    return item.value;
  }
  // 如果没有设置失效时间，直接返回值
  return !item ? false : item;
}

export default {
  commit,
  showload,
  hidload,
  showMessage,
  parseUrl,
  Message,
  pay,
  showLogin,
  setItem,
  getItem,
};
